<template>
  <v-container fluid pt-0>
    <v-layout wrap v-if="false">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Layout Options</v-expansion-panel-header>
          <v-expansion-panel-content key="filters">
            <v-layout justify-end align-center>
              <v-flex pa-0 xs-12 sm-7> </v-flex>

              <v-flex xs12 sm5>
                <v-layout justify-end pr-1 v-if="selectedView == 'grouped'">
                  <v-flex xs12 sm4>
                    <v-combobox
                      v-model="groupBy"
                      :items="groupByOptions"
                      item-text="label"
                      label="Group By:"
                      class="py-0 my-0"
                    ></v-combobox>
                  </v-flex>
                </v-layout>
                <v-layout justify-end pr-1 v-if="selectedView == 'day_by_day'">
                  <v-switch
                    label="Open/Close All Days"
                    class="pr-3 py-0 my-0"
                    v-model="openAllDays"
                  ></v-switch>
                  <v-switch
                    label="Show All Services"
                    v-model="dbdShowAllServices"
                    class="py-0 my-0"
                  ></v-switch>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout wrap align-baseline>
              <v-flex xs12 sm8 class="pa-2">
                <v-select
                  label="Visible Columns"
                  :items="headersForView"
                  v-model="visibleColumns"
                  multiple
                  item-value="name"
                  chips
                  deletable-chips
                  @change="onVisibleColumnsChange"
                  :outlined="outlinedInputs"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 class="pa-2" v-if="tableView">
                <v-text-field
                  append-icon="mdi-magnify"
                  label="Quick Filter..."
                  single-line
                  hide-details
                  v-model="search"
                  :outlined="outlinedInputs"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-layout>
    <v-row v-if="selectedView == 'drag'">
      <v-col cols="12" class="py-0">
        <v-row justify="end">
          <v-col>
            <itinerary-builder-settings></itinerary-builder-settings>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <itinerary-builder-drag-and-drop
              :key="dataTableKey"
              :header-props="headerProps"
              :items="items"
              @change="ondDdChange"
              @item-edit="onItemEdit"
              @item-delete="onItemRemove"
              @item-changed="onItemChanged"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="selectedView == 'table'">
      <v-col cols="12" class="py-0">
        <v-row justify="end">
          <v-col>
            <itinerary-builder-settings></itinerary-builder-settings>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-container py-0>
              <v-row justify="end" align="center">
                <v-slider
                  v-if="!showAgGrid"
                  hide-details
                  label="Font Size"
                  max="36"
                  min="2"
                  v-model="fontSize"
                ></v-slider>
                <ag-grid-switch
                  :name="refNameColumns"
                  class="mr-1"
                ></ag-grid-switch>
                <list-visible-columns-and-filter
                  :visible-columns="visibleColumns"
                  :selectable-headers="headersForView"
                  v-model="search"
                  @change="onVisibleColumnsChange"
                >
                  <items-list-hide-filters
                    v-model="hideFilters"
                    @change="onHideFiltersChange"
                  ></items-list-hide-filters>
                </list-visible-columns-and-filter>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <div v-if="items.length > 0">
          <div v-if="showAgGrid" key="ag-grid">
            <ag-grid-vue
              class="ag-theme-alpine"
              id="ag-it-builder-items-list"
              :columnDefs="itiItemsListAgGridColumns"
              :rowData="itemsWithExtras"
              rowSelection="multiple"
              :context="agContext"
              @grid-ready="onAgGridReady"
              @columnMoved="onAgColumnMoved"
              @columnResized="onAgColumnResized"
              @selection-changed="onAgSelectionChanged"
              @newColumnsLoaded="onAgNewColumns"
              :frameworkComponents="frameworkComponents"
              suppressDragLeaveHidesColumns
              @cellEditingStarted="onAgGridCellEditStart"
            >
            </ag-grid-vue>
            <v-speed-dial
              v-show="selectedRows.length > 0"
              open-on-hover
              absolute
              direction="right"
              v-model="modifyServicesFab"
            >
              <template v-slot:activator>
                <v-btn
                  v-model="modifyServicesFab"
                  color="blue darken-2"
                  dark
                  fab
                >
                  <v-icon v-if="modifyServicesFab">mdi-close</v-icon>
                  <v-icon v-else>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-btn fab dark small color="indigo" @click="onShowMoveDays">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-calendar</v-icon>
                  </template>
                  <span>Move Days</span>
                </v-tooltip>
              </v-btn>
              <v-btn fab dark small color="green" @click="onReorderServices">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-sort</v-icon>
                  </template>
                  <span>Reorder Services</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="blue"
                @click="onCustomPriceToggle"
                v-if="canEditPrices"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-currency-usd</v-icon>
                  </template>
                  <span>Custom Price on</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="orange"
                @click="onZeroPrices"
                v-if="canEditPrices"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-numeric-0</v-icon>
                  </template>
                  <span>Set Zero Sell Prices</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="pink"
                @click="onPriceAdjuster"
                v-if="canEditPrices && $store.getters.hasAccessTo('itineraries:adjust_prices')"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-percent</v-icon>
                  </template>
                  <span>Adjust Prices</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="indigo lighten-1"
                @click="onShowPaxUpdater"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-account</v-icon>
                  </template>
                  <span>Update Pax</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="red"
                @click="onRemoveSelectedServices"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-delete</v-icon>
                  </template>
                  <span>Remove Services</span>
                </v-tooltip>
              </v-btn>
              <v-btn fab dark small color="green" @click="onShowUpdateStatus">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-check</v-icon>
                  </template>
                  <span>Update Status</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="pink"
                @click="onRefreshPrices"
                v-if="canEditPrices"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-refresh</v-icon>
                  </template>
                  <span>Refresh Prices</span>
                </v-tooltip>
              </v-btn>
            </v-speed-dial>
          </div>

          <div v-else :style="{ fontSize: fontSize + 'px!important' }">
            <v-card class="pt-3" outlined>
              <v-data-table
                :headers="filteredHeaders"
                :items="itemsWithExtras"
                :search="search"
                v-bind="pagingOptions"
                show-select
                v-model="selectedRows"
                @current-items="current = $event"
                @item-selected="bulkSelect"
                item-key="id"
                :key="dataTableKey"
                :sort-by="sortBy"
                class="iti-items-list"
                @update:sort-by="onSortByUpdate"
                unselectable
                :height="gridHeight"
                :fixed-header="fixedHeader"
              >
                <template v-slot:item.boardBasis="{ item }">
                  <v-edit-dialog :return-value.sync="item.boardBasis" large>
                    {{ item.boardBasis }}
                    <template v-slot:input>
                      <board-basis-list-select
                        v-model="item.boardBasis"
                      ></board-basis-list-select>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.businessModel="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{
                        item.businessModel
                      }}</span>
                    </template>
                    <span>{{ item.businessModelName }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.supplierCommission="{ item }">
                  {{ item.supplierCommissionValue | priceLabeler }}
                </template>
                <template v-slot:item.startDate="{ item }">
                  <span v-if="item.isExtra">
                    {{ item.startDate | formatDate }}
                  </span>
                  <v-edit-dialog
                    v-else
                    :return-value.sync="item.startDate"
                    large
                    @save="onDateChange(item)"
                  >
                    {{ item.startDate | formatDate }}
                    <template v-slot:input>
                      <v-row>
                        <v-date-picker
                          v-model="item.startDate"
                          :min="headerProps.startDate"
                          :max="item.endDate"
                        ></v-date-picker>
                      </v-row>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.endDate="{ item }">
                  <span v-if="item.isExtra">
                    {{ item.endDate | formatDate }}
                  </span>
                  <v-edit-dialog
                    v-else
                    :return-value.sync="item.endDate"
                    large
                    @save="onDateChange(item)"
                  >
                    {{ item.endDate | formatDate }}
                    <template v-slot:input>
                      <v-row>
                        <v-date-picker
                          v-model="item.endDate"
                          :min="item.startDate"
                          :max="headerProps.endDate"
                        ></v-date-picker>
                      </v-row>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-edit-dialog
                    :return-value.sync="item.status"
                    large
                    v-if="item.allowStatusChange"
                  >
                    {{ item.status }}
                    <template v-slot:input>
                      <service-status-list-select
                        :is-disabled="false"
                        v-model="item.statusId"
                        @onSelect="onItemStatusSelect(item, $event)"
                      ></service-status-list-select>
                    </template>
                  </v-edit-dialog>
                  <span v-else>
                    {{ item.status }}
                  </span>
                </template>
                <template v-slot:item.serviceType="{ item }">
                  <v-icon>{{ supplierTypeIcon(item.serviceType) }}</v-icon>
                </template>
                <template v-slot:item.orderNo="{ item }">
                  <v-edit-dialog :return-value.sync="item.orderNo" lazy large>
                    {{ item.orderNo }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.orderNo"
                        label="Edit"
                        single-line
                        type="number"
                        @change="onOrderNoChange(item)"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.supplierComp="{ item }">
                  <v-edit-dialog
                    :return-value.sync="item.supplierComp"
                    lazy
                    large
                    @save="onCompsSave"
                    v-if="basicComps"
                  >
                    {{ item.supplierComp }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.supplierComp"
                        label="Edit"
                        single-line
                        type="number"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <v-btn v-else text @click="onShowItiComps">{{
                    item.supplierComp
                  }}</v-btn>
                </template>
                <template v-slot:item.passComp="{ item }">
                  <v-edit-dialog
                    :return-value.sync="item.passComp"
                    lazy
                    large
                    @save="onCompsSave"
                    v-if="basicComps"
                  >
                    {{ item.passComp }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.passComp"
                        label="Edit"
                        single-line
                        type="number"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <v-btn v-else text @click="onShowItiComps">{{
                    item.passComp
                  }}</v-btn>
                </template>
                <template v-slot:item.remarks.pickupTime="{ item }">
                  <v-edit-dialog
                    :return-value.sync="item.remarks.pickupTime"
                    large
                  >
                    <v-icon left small class="mx-0">access_time</v-icon>
                    {{
                      item.remarks.pickupTime != ""
                        ? item.remarks.pickupTime
                        : "Set Time"
                    }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.remarks.pickupTime"
                        @change="onTimeChange(item)"
                        label="Edit"
                        type="time"
                        clearable
                        required
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.remarks.dropoffTime="{ item }" large>
                  <v-edit-dialog
                    :return-value.sync="item.remarks.dropoffTime"
                    large
                  >
                    <v-icon left small class="mx-0">access_time</v-icon>
                    {{
                      item.remarks.dropoffTime != ""
                        ? item.remarks.dropoffTime
                        : "Set Time"
                    }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.remarks.dropoffTime"
                        @change="onTimeChange(item)"
                        label="Edit"
                        type="time"
                        clearable
                        required
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:item.duration="{ item }">
                  {{ duration(item) }}
                </template>
                <template v-slot:item.supplierName="{ item }">
                  <supplier-label
                    v-model="item.supplierName"
                    :supplier-type="item.serviceType"
                    :supplier-id="item.supplierId"
                    :callback="onShowSupplier(item)"
                    :source="item.source"
                    :year-shift="item.yearShift"
                    :link-parent="item.linkParent"
                  ></supplier-label>
                </template>
                <template v-slot:item.serviceName="{ item }">
                  <v-row v-if="item.isExtra" align="center">
                    <v-icon color="yellow darken-2">mdi-star</v-icon>
                    {{ item.boardBasis }} ({{ item.serviceName }})
                  </v-row>
                  <span v-else>{{ item.serviceName }}</span>
                </template>
                <template v-slot:item.ratePlan="{ item }">
                  {{ ratePlanLabeler(item) }}
                </template>
                <template v-slot:item.pax="{ item }">
                  {{ paxLabeler(item) }}
                </template>
                <template v-slot:item.price="{ item }">
                  {{ item.price | priceLabeler }}
                </template>
                <template v-slot:item.lastUpdated="{ item }">
                  {{ item.lastUpdated | formatDateTime }}
                </template>
                <template v-slot:item.isIncluded="{ item }">
                  <v-layout justify-center>
                    <v-checkbox
                      class="pa-0 ma-0"
                      v-model="item.isIncluded"
                      hide-details
                      :disabled="
                        flagsEditDisabled(item) ||
                        (item.isExtra && !parentIsIncluded(item))
                      "
                      @change="onIsIncludedChange(item)"
                    ></v-checkbox>
                  </v-layout>
                </template>
                <template v-slot:item.isOptional="{ item }">
                  <v-layout justify-center>
                    <v-checkbox
                      class="pa-0 ma-0"
                      v-model="item.isOptional"
                      hide-details
                      :disabled="
                        flagsEditDisabled(item) ||
                        (item.isExtra && parentIsOptional(item))
                      "
                      @change="onIsOptionalChange(item)"
                    ></v-checkbox>
                  </v-layout>
                </template>
                <template v-slot:item.isHidden="{ item }">
                  <v-simple-checkbox
                    :disabled="item.isExtra && parentIsHidden(item)"
                    v-model="item.isHidden"
                    @input="onIsHiddenChange(item, $event)"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.includeCommission="{ item }">
                  <v-simple-checkbox
                    v-model="item.includeCommission"
                    @input="onIncludeCommissionChange(item, $event)"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-layout class="d-flex flex-no-wrap">
                    <v-btn
                      small
                      icon
                      @click="onItemEdit(item)"
                      :disabled="item.isExtra"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small color="teal" v-on="on"
                            >mdi-pencil</v-icon
                          >
                        </template>
                        <span>Modify Item</span>
                      </v-tooltip>
                    </v-btn>

                    <v-btn
                      icon
                      small
                      @click="onEditItemPrices(item)"
                      v-if="item.serviceType != 'MANDATORY_CHARGES'"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            :color="customPricingFlagColor(item)"
                            small
                            v-on="on"
                            >{{
                              item.customPricing
                                ? "mdi-currency-usd"
                                : "mdi-currency-usd-off"
                            }}</v-icon
                          >
                        </template>
                        <span>Pricing</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn icon small @click="onEditRemarks(item)">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" small v-on="on"
                            >mdi-note-outline</v-icon
                          >
                        </template>
                        <span>Remarks</span>
                      </v-tooltip>
                    </v-btn>
                    <v-avatar
                      v-if="item.allocation && item.allocation != ''"
                      color="indigo lighten-2"
                      size="26"
                      dark
                      ><span class="white--text"
                        ><strong>FA</strong></span
                      ></v-avatar
                    >
                    <v-tooltip bottom v-if="item.hasPurchaseInvoice">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-variant</v-icon>
                      </template>
                      <span
                        >This service cannot be deleted because there is a
                        purchase invoice associated with it. If you remove the
                        purchase invoice in the Accounts section then you can
                        delete this service.</span
                      >
                    </v-tooltip>
                    <confirmation-dialog
                      @onConfirm="onItemRemove"
                      :item="item"
                      v-else-if="itemIsDeletable(item)"
                    >
                      <v-btn small icon :disabled="item.isExternal">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small color="pink" v-on="on"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Remove Item</span>
                        </v-tooltip>
                      </v-btn>
                      <p slot="message">This will remove service.</p>
                    </confirmation-dialog>
                  </v-layout>
                </template>

                <template v-slot:footer>
                  <v-speed-dial
                    v-show="selectedRows.length > 0"
                    open-on-hover
                    absolute
                    direction="right"
                    v-model="modifyServicesFab"
                  >
                    <template v-slot:activator>
                      <v-btn
                        v-model="modifyServicesFab"
                        color="blue darken-2"
                        dark
                        fab
                      >
                        <v-icon v-if="modifyServicesFab">mdi-close</v-icon>
                        <v-icon v-else>mdi-menu</v-icon>
                      </v-btn>
                    </template>
                    <v-btn
                      fab
                      dark
                      small
                      color="indigo"
                      @click="onShowMoveDays"
                      v-if="!selectedIncludeExternalServices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                        <span>Move Days</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      @click="onReorderServices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-sort</v-icon>
                        </template>
                        <span>Reorder Services</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="blue"
                      @click="onCustomPriceToggle"
                      v-if="canEditPrices && !selectedIncludeExternalServices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-currency-usd</v-icon>
                        </template>
                        <span>Custom Price on</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="orange"
                      @click="onZeroPrices"
                      v-if="canEditPrices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-numeric-0</v-icon>
                        </template>
                        <span>Set Zero Sell Prices</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="pink"
                      @click="onPriceAdjuster"
                      v-if="
                        canEditPrices &&
                        $store.getters.hasAccessTo('itineraries:adjust_prices')
                      "
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-percent</v-icon>
                        </template>
                        <span>Adjust Prices</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="indigo lighten-1"
                      @click="onShowPaxUpdater"
                      v-if="!selectedIncludeExternalServices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-account</v-icon>
                        </template>
                        <span>Update Pax</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="teal accent-4"
                      @click="onShowExchangeRateUpdater"
                      v-if="canEditPrices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-currency-usd</v-icon>
                        </template>
                        <span>Update Exchange Rate</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                      @click="onRemoveSelectedServices"
                      v-if="!selectedIncludeExternalServices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Remove Services</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      @click="onShowUpdateStatus"
                      v-if="!selectedIncludeExternalServices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-check</v-icon>
                        </template>
                        <span>Update Status</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="pink"
                      @click="onRefreshPrices"
                      v-if="canEditPrices"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-refresh</v-icon>
                        </template>
                        <span>Refresh Prices</span>
                      </v-tooltip>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>

    <itinerary-builder-items-list-day-by-day
      v-if="selectedView == 'day_by_day'"
      :items="itemsWithExtras"
      :start-date="headerProps.startDate"
      :end-date="headerProps.endDate"
      :currency-code="currencyCode"
      :headers="filteredHeaders"
      :visible-columns="visibleColumns"
      :open-all="openAllDays"
      :show-all-services="dbdShowAllServices"
      :basic-comps="basicComps"
      @itemRemove="onItemRemove"
      @itemEditPrices="onEditItemPrices"
      @itemEdit="onItemEdit"
      @addItem="onAddItem"
      @addAdhoc="onAddAdhoc"
      @addTemplate="onAddTemplate"
      @onRecalculate="onRecalculate"
      @addCharge="onAddCharge"
      @supplier-edit="onSupplierEdit"
      @addFromAllocations="onAddFromAllocations"
      :key="dataTableKey"
      :flagsEditDisabledFn="flagsEditDisabled"
      @showMoveDays="onShowMoveDays"
      @reorderSelectedServices="onReorderServices"
      @customPriceToggle="onCustomPriceToggle"
      @zeroSelectedServices="onZeroPrices"
      @showPaxUpdater="onShowPaxUpdater"
      @removeSelectedServices="onRemoveSelectedServices"
      @showUpdateStatus="onShowUpdateStatus"
      @showItiComps="onShowItiComps"
      @showRemarksEdit="onEditRemarks"
      @showPriceAdjuster="onPriceAdjuster"
      @orderNoChange="onOrderNoChange"
      @refreshPrices="onRefreshPrices"
      @timeChange="onTimeChange"
      @isIncludedChange="onIsIncludedChange"
      @isOptionalChange="onIsOptionalChange"
      :search="search"
    >
      <v-row align="center">
        <v-col class="py-0">
          <itinerary-builder-settings></itinerary-builder-settings>
        </v-col>
        <v-col class="py-0">
          <v-container py-0>
            <v-row justify="end">
              <list-visible-columns-and-filter
                :visible-columns="visibleColumns"
                :selectable-headers="headersForView"
                v-model="search"
                @change="onVisibleColumnsChange"
              >
              </list-visible-columns-and-filter>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </itinerary-builder-items-list-day-by-day>
    <pricing-view
      v-if="selectedView == 'pricing'"
      :items="itemsWithExtras"
      :itinerary="itinerary"
      :basic-comps="basicComps"
      @recalculate="onRecalculate"
      @update-exchange-rates="onUpdateExchangeRates"
      @onTimeChange="onTimeChange"
      :search="search"
    />
    <itinerary-builder-items-list-grouped
      v-if="selectedView == 'grouped'"
      :group="groupBy"
      :visible-columns="visibleColumns"
      :items="itemsWithExtras"
      :headers="filteredHeaders"
      :currency-code="currencyCode"
      :basic-comps="basicComps"
      @itemRemove="onItemRemove"
      @itemEditPrices="onEditItemPrices"
      @itemEdit="onItemEdit"
      @addItem="onAddItem"
      @addAdhoc="onAddAdhoc"
      @addTemplate="onAddTemplate"
      @addCharge="onAddCharge"
      @onRecalculate="onRecalculate"
      @addFromAllocations="onAddFromAllocations"
      @supplier-edit="onSupplierEdit"
      :key="dataTableKey"
      :flagsEditDisabledFn="flagsEditDisabled"
      @showMoveDays="onShowMoveDays"
      @reorderSelectedServices="onReorderServices"
      @customPriceToggle="onCustomPriceToggle"
      @zeroSelectedServices="onZeroPrices"
      @showPaxUpdater="onShowPaxUpdater"
      @removeSelectedServices="onRemoveSelectedServices"
      @showUpdateStatus="onShowUpdateStatus"
      @showItiComps="onShowItiComps"
      @showRemarksEdit="onEditRemarks"
      @showPriceAdjuster="onPriceAdjuster"
      @orderNoChange="onOrderNoChange"
      @refreshPrices="onRefreshPrices"
      @timeChange="onTimeChange"
      @isIncludedChange="onIsIncludedChange"
      @isOptionalChange="onIsOptionalChange"
      :search="search"
    >
      <v-row align="center">
        <v-col class="py-0">
          <itinerary-builder-settings></itinerary-builder-settings>
        </v-col>
        <v-col class="py-0">
          <v-container py-0>
            <v-row justify="end">
              <list-visible-columns-and-filter
                :visible-columns="visibleColumns"
                :selectable-headers="headersForView"
                v-model="search"
                @change="onVisibleColumnsChange"
              >
                <v-combobox
                  v-model="groupBy"
                  :items="groupByOptions"
                  item-text="label"
                  label="Group By:"
                  class="py-0 my-0"
                  :outlined="outlinedInputs"
                ></v-combobox>
                <items-list-hide-filters
                  v-model="hideFilters"
                  @change="onHideFiltersChange"
                ></items-list-hide-filters>
              </list-visible-columns-and-filter>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </itinerary-builder-items-list-grouped>
    <itinerary-builder-items-list-item-editor
      class="item-editor-dialog"
      @onCancel="onItemEditCancel($event)"
      @onSave="onItemEditSave"
      @external-confirmed="onItemConfirmed"
      :selected-item="selectedItem"
      :all-provider-items="allProviderItems"
      :show="showEditor"
      :participants="participants"
      :header-props="headerProps"
      :isNewItem="isNewItem"
      @showAdhoc="showAdhocFromQuickAdd"
      @showAdhocFromEdit="showAdhocFromEdit"
      @supplier-edit="onSupplierEdit"
      @show-remarks-editor="onShowRemarksFromEditor"
    ></itinerary-builder-items-list-item-editor>
    <itinerary-builder-move-days
      :show="showMoveDays"
      @onCancel="onMoveDaysCancel"
      @onMoveDays="onMoveDays($event)"
    ></itinerary-builder-move-days>
    <exchange-rate-updater
      :show="showExchangeRateUpdater"
      @close="showExchangeRateUpdater = false"
      :items="selectedRows"
      @update-exchange-rates="onUpdateExchangeRates"
    />
    <update-status-dialog
      :show="showUpdateStatus"
      @close="showUpdateStatus = false"
      @update="onUpdateStatus"
    ></update-status-dialog>
    <pax-update-dialog
      :show="showPaxUpdater"
      @close="showPaxUpdater = false"
      @update="onPaxUpdate"
      :headerProps="headerProps"
      :items="selectedRows"
    ></pax-update-dialog>
    <item-pricing-dialog
      :show="showItemPricingEditor"
      :selected-item="selectedItem"
      :headerProps="headerProps"
      @onCancel="showItemPricingEditor = false"
      @onSave="onPricingSave"
    ></item-pricing-dialog>
    <remarks-edit-dialog
      v-model="selectedItem"
      @close="showRemarksEditor = false"
      @save="onSaveRemarks"
      :show="showRemarksEditor"
    />
    <price-adjuster
      :show="showPriceAdjuster"
      @close="showPriceAdjuster = false"
      @save="onPriceAdjustment"
    />

    <v-layout justify-space-around>
      <p class="pt-2 pb-0 ma-0">
        Total
        <strong>{{ totalPrice | priceLabeler }}</strong>
        {{ currencyCode }}
      </p>
    </v-layout>
    <v-row v-if="items.length == 0 || selectedView == 'table'">
      <v-col cols="12">
        <v-row justify="center" class="pt-3">
          <v-btn
            text
            color="primary"
            @click="onRatesSearch"
            v-if="$store.getters.hasAccessTo('third_party:visible')"
          >
            <v-icon left>mdi-magnify</v-icon>Rates Search
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="onAddItem"
            v-if="!$store.getters.hasAccessTo('itineraries:hide_quick_access')"
          >
            <v-icon left>mdi-plus-circle</v-icon>Quick Add
          </v-btn>
          <v-btn text color="primary" @click="onAddAdhoc">
            <v-icon left>mdi-plus-circle</v-icon>Add Service
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="onAddTemplate"
            v-if="!$store.getters.hasAccessTo('itineraries:hide_add_template')"
          >
            <v-icon left>mdi-plus-circle</v-icon>Add Template
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="onAddCharge"
            v-if="!$store.getters.hasAccessTo('itineraries:hide_add_charge')"
          >
            <v-icon left>mdi-plus-circle</v-icon>Add Charge
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="onAddFromAllocations"
            v-if="
              !$store.getters.hasAccessTo('itineraries:hide_add_allocation')
            "
          >
            <v-icon left>mdi-plus-circle</v-icon>Add From Allocations
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="debug">
      <code> search {{ search }}</code>
    </div>
  </v-container>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import ListBulkSelect from "../../../../mixins/ListBulkSelect";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import ItineraryBuilderItemsListItemEditor from "./ItineraryBuilderItemsListItemEditor";
import ItineraryBuilderMoveDays from "./tools/ItineraryBuilderMoveDays";
import ItemPricingDialog from "./tools/ItemPricingDialog";
import ItineraryBuilderItemsListGrouped from "./ItineraryBuilderItemsListGrouped";
import ItineraryBuilderItemsListDayByDay from "./ItineraryBuilderItemsListDayByDay";
import BoardBasisListSelect from "../../shared/BoardBasisListSelect";
import PricingView from "./PricingView";
import {
  getItiItemOrder,
  removeGQLTypename,
  sortByDate,
  pagingOptions,
  groupByProp,
} from "../../../../helpers";

import ItineraryBuilderSettings from "./ItineraryBuilderSettings";
import SupplierLabel from "../../shared/labels/SupplierLabel";
import TimeLabel from "../../shared/labels/TimeLabel";
import UpdateStatusDialog from "./tools/UpdateStatusDialog";
import PaxUpdateDialog from "./tools/PaxUpdateDialog";
import { BUSINESS_MODELS } from "./graphql";
import AgGridSwitch from "../../shared/AgGridSwitch.vue";
import { AgGridVue } from "ag-grid-vue";
import AgGridListMixin from "../../../../mixins/AgGridListMixin";
import AgCellDateEditor from "../../shared/ag-grid/AgCellDateEditor.js";
import AgCellBooleanEditor from "../../shared/ag-grid/AgCellBooleanEditor";
import AgBoardBasisEditor from "../../shared/ag-grid/AgGridBoardBasisEditor";
import AgNumberEditor from "../../shared/ag-grid/AgNumberEditor";
import AgServiceStatusEditor from "../../shared/ag-grid/AgServiceStatusEditor";
import AgCellTimeEditor from "../../shared/ag-grid/AgGridCellTimeEditor";
import ItineraryListItemsActions from "./ItineraryItemsListActions";
import ServiceTypeLabel from "../../shared/labels/ServiceTypeLabel";
import BasisLabel from "../../shared/labels/BasisLabel";
import ServiceNameLabel from "../../shared/labels/ServiceNameLabel";
import EventBus from "../../../../store/event-bus";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";
import ServiceStatusListSelect from "../../shared/ServiceStatusListSelect";
import ItineraryBuilderDragAndDrop from "./ItineraryBuilderDragAndDrop";
import PricingLogMixin from "./mixins/pricing-log";
import ExchangeRateUpdater from "./tools/ExchangeRateUpdater.vue";
import RemarksEditDialog from "./tools/RemarksEditDialog.vue";
import ItemsListHideFilters from "./tools/ItemsListHideFilters.vue";
import { updateTransportPrice } from "./tools/helpers";
import { ALL_RATE_TYPES_SEARCH_QUERY } from "../../../../constants/graphql";
import PriceAdjuster from "./tools/PriceAdjuster.vue";
var randomize = require("randomatic");
var moment = require("moment");
export default {
  name: "itinerary-builder-items-list",

  mixins: [
    SupplierTypeIconMixin,
    AgGridListMixin,
    ListBulkSelect,
    PricingLogMixin,
  ],

  props: {
    participants: {
      type: Array,
      default: () => [],
    },
    currencyCode: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    newItem: {
      type: Object,
    },
    headerProps: {
      type: Object,
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
    refName: {
      type: String,
      default: () => "iti-builder-items-list",
    },
    refNameColumns: {
      type: String,
      default: () => "iti-builder-items-list-cols",
    },
    basicComps: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
    ConfirmationDialog,
    ItineraryBuilderItemsListItemEditor,
    ItineraryBuilderMoveDays,
    ItemPricingDialog,
    ItineraryBuilderItemsListGrouped,
    ItineraryBuilderItemsListDayByDay,
    ItineraryBuilderSettings,
    SupplierLabel,
    TimeLabel,
    UpdateStatusDialog,
    PaxUpdateDialog,
    BoardBasisListSelect,
    AgGridSwitch,
    AgGridVue,
    ItineraryListItemsActions,
    ServiceTypeLabel,
    AgCellBooleanEditor,
    AgCellTimeEditor,
    AgServiceStatusEditor,
    AgBoardBasisEditor,
    AgNumberEditor,
    BasisLabel,
    ServiceNameLabel,
    ListVisibleColumnsAndFilter,
    ServiceStatusListSelect,
    PricingView,
    ItineraryBuilderDragAndDrop,
    ExchangeRateUpdater,
    RemarksEditDialog,
    ItemsListHideFilters,
    PriceAdjuster,
  },
  data() {
    return {
      debug: false,
      fontSize: 12,
      pagingOptions,
      dataTableKey: randomize("Aa0", 32),
      fixedHeader: true,
      tableView: true,

      modifyServicesFab: false,
      search: "",
      // day by day view options
      openAllDays: true,
      dbdShowAllServices: true,
      //
      groupBy: {
        label: "Supplier Type",
        fieldName: "serviceType",
      },
      groupByOptions: [
        // {
        //   label: "Day",
        //   fieldName: "startDate"
        // },
        {
          label: "Supplier Type",
          fieldName: "serviceType",
        },
        {
          label: "Supplier",
          fieldName: "supplierName",
        },
        {
          label: "Status",
          fieldName: "status",
        },
      ],

      isNewItem: true,
      headers: [
        {
          text: "Type",
          value: "serviceType",
          sortable: true,
          name: "serviceType",
          cellRendererFramework: "ServiceTypeLabel",
        },
        {
          text: "Order",
          value: "orderNo",
          sortable: true,
          name: "orderNo",
          editable: true,
        },
        {
          text: "From",
          value: "startDate",
          name: "startDate",
          sort: sortByDate,
          editable: true,
          cellEditor: "dateEditor",
          sortable: true,
          valueGetter: (payload) =>
            this.$options.filters.formatDate(payload.data.startDate),
          onCellValueChanged: (params) => {
            //console.log("start date edit finished", params);
          },
        },
        {
          text: "To",
          value: "endDate",
          name: "endDate",
          sort: sortByDate,
          sortable: true,
          editable: true,
          cellEditor: "dateEditor",
          valueGetter: (payload) =>
            this.$options.filters.formatDate(payload.data.endDate),
        },
        {
          text: "Duration",
          value: "duration",
          name: "duration",
          sortable: true,
          valueGetter: (payload) => this.duration(payload.data),
        },
        {
          text: "Supplier",
          value: "supplierName",
          class: "hidden-sm-and-down",
          name: "supplierName",
          cellRendererFramework: "SupplierLabel",
          sortable: true,
          width: "300px",
        },
        {
          text: "Supplier Destination",
          value: "supplierDestination",
          class: "hidden-sm-and-down",
          name: "supplierDestination",
          sortable: true,
        },
        {
          text: "Service",
          value: "serviceName",
          name: "serviceName",
          sortable: true,
          cellRendererFramework: "ServiceNameLabel",
          width: "225px",
        },
        {
          text: "Service Alt Name",
          value: "serviceAltName",
          name: "serviceAltName",
          sortable: true,
        },
        {
          text: "Status",
          value: "status",
          class: "hidden-sm-and-down",
          editable: true,
          cellEditor: "statusEditor",
          name: "status",
          sortable: true,
        },
        {
          text: "Basis/Extra",
          value: "boardBasis",
          class: "hidden-sm-and-down",
          name: "boardBasis",
          editable: true,
          cellEditor: "basisEditor",
          cellRendererFramework: "BasisLabel",
          sortable: true,
          width: "300px",
        },
        {
          text: "Ad/Ch/Inf",
          value: "pax",
          class: "hidden-sm-and-down",
          name: "pax",
          valueGetter: (p) =>
            `${p.data.adults}/${p.data.children}/${p.data.infants}`,
          sortable: true,
        },
        {
          text: "Qty",
          value: "qty",
          class: "hidden-sm-and-down",
          name: "qty",
          sortable: true,
        },
        {
          text: "Rate Type",
          value: "rateTypeCode",
          class: "hidden-sm-and-down",
          name: "rateTypeCode",
          sortable: true,
        },
        {
          text: "Rate Plan",
          value: "ratePlan",
          class: "hidden-sm-and-down",
          name: "ratePlan",
          sortable: true,
          valueGetter: (payload) =>
            payload.data.pricing ? payload.data.pricing.ratePlan : "",
        },
        { text: "Price", value: "price", name: "price", sortable: true },
        {
          text: "Include",
          value: "isIncluded",
          name: "isIncluded",
          align: "center",
          cellRenderer: "boolEditor",
          sortable: true,
        },
        {
          text: "Optional",
          value: "isOptional",
          name: "isOptional",
          align: "center",
          cellRenderer: "boolEditor",
          sortable: true,
        },
        {
          text: "No Report",
          value: "isHidden",
          name: "isHidden",
          align: "center",
          cellRenderer: "boolEditor",
          sortable: true,
        },
        {
          text: "Commission",
          value: "includeCommission",
          name: "includeCommission",
          align: "center",
          cellRenderer: "boolEditor",
          sortable: true,
        },
        {
          text: "Start Time",
          value: "remarks.pickupTime",
          name: "pickupTime",
          align: "center",
          editable: true,
          cellEditor: "timeEditor",
          valueGetter: (payload) =>
            payload.data.remarks ? payload.data.remarks.pickupTime : "",
          sortable: true,
          width: "120px",
        },
        {
          text: "End Time",
          value: "remarks.dropoffTime",
          name: "dropoffTime",
          align: "center",
          editable: true,
          cellEditor: "timeEditor",
          valueGetter: (payload) =>
            payload.data.remarks ? payload.data.remarks.dropoffTime : "",
          sortable: true,
          width: "120px",
        },
        {
          text: "Business Model",
          value: "businessModel",
          name: "businessModel",
          align: "center",
          sortable: true,
        },
        {
          text: "Supplier Commission",
          value: "supplierCommission",
          name: "supplierCommission",
          align: "center",
          sortable: true,
        },
        {
          text: "Supplier Comp",
          value: "supplierComp",
          name: "supplierComp",
          align: "center",
          sortable: true,
          editable: true,
        },
        {
          text: "Pass Comp",
          value: "passComp",
          name: "passComp",
          align: "center",
          sortable: true,
          editable: true,
        },
        {
          text: "Last Updated",
          value: "lastUpdated",
          name: "lastUpdated",
          sortable: false,
          valueGetter: (payload) =>
            payload.data.lastUpdated ? payload.data.lastUpdated : "",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          cellRendererFramework: "ItineraryListItemsActions",
          sortable: true,
        },
      ],
      showEditor: false,
      selectedItem: null,
      allProviderItems: [],
      showMoveDays: false,
      showItemPricingEditor: false,
      showAddServiceDialog: false,
      showUpdateStatus: false,
      showPaxUpdater: false,
      showExchangeRateUpdater: false,
      frameworkComponents: {
        dateEditor: AgCellDateEditor,
        boolEditor: AgCellBooleanEditor,
        timeEditor: AgCellTimeEditor,
        statusEditor: AgServiceStatusEditor,
        basisEditor: AgBoardBasisEditor,
        numberEditor: AgNumberEditor,
      },
      visibleColumns: this.$store.getters.localSettings(this.refNameColumns, [
        "orderNo",
        "startDate",
        "supplierName",
        "serviceName",
        "qty",
        "pax",
        "price",
        "status",
        "actions",
      ]),
      showRemarksEditor: false,
      hideFilters: this.$store.getters.localSettings("itBuilderHideFilters"),
      windowHeight: window.innerHeight,
      showPriceAdjuster: false,
    };
  },

  computed: {
    notCancelled() {
      return this.allProviderItems.filter((item) => {
        return !item.status.toString().toUpperCase().includes("CANCELLED");
      });
    },
    notCanceledAndNotConfirmed() {
      return this.allProviderItems.filter((item) => {
        const status = item.status.toString().toUpperCase();
        return !status.includes("CANCELLED") && !status.includes("CONFIRMED");
      });
    },
    selectedIncludeExternalServices() {
      return this.selectedRows.find((item) => item.isExternal) != null;
    },
    itiItemsListAgGridColumns() {
      return this.agGridColumns.map((col) => ({
        ...col,
        sort: col.field == this.sortBy ? "asc" : undefined,
      }));
    },
    fromIncrement() {
      return this.items.find((item) => item.serviceName == "TO ZERO PRICES");
    },
    itemsWithExtras() {
      this.selectedRows = [];
      return this.items.reduce((list, item) => {
        item.isExternal = item.source && item.source.name != "GTWEB";
        item.allowStatusChange = true; //!item.isExternal || (item.source && item.source.name == "RESREQUEST"); //https://tracker.globetrack.ie/issues/8793
        if (item.ratePlan == "" && item.pricing) {
          item.ratePlan = item.pricing.ratePlan;
        }
        //check for linked services
        const itemLinkedServices = this.items.filter(
          (i) => i.parentId == item.id
        );
        item.linkedServices = itemLinkedServices;
        if (item.parentId && item.parentId != "") {
          const parent = this.items.find((i) => i.id == item.parentId);
          if (parent) {
            item.linkParent = `${parent.supplierName} - ${parent.serviceName}`;
          }
        }
        list.push(item);
        if (item.extras) {
          for (const extra of item.extras) {
            //console.log("extra", extra);
            const extraService = {
              ...item,
              id: randomize("Aa0", 32),
              itemId: item.id,
              extraId: extra.id,
              isExtra: true,
              toms: extra.toms,
              pricing: {
                ...item.pricing,
                logs:
                  extra.pricing && extra.pricing.logs
                    ? [...extra.pricing.logs]
                    : [],
              },
              isHidden: extra.isHidden,
              isOptional: extra.isOptional,
              isIncluded: extra.isIncluded,
              status: extra.status,
              statusId: extra.statusId,
              currencyBuy: extra.currencyBuy,
              currencyBuyExchangeRate: extra.currencyBuyExchangeRate,
            };

            extraService.boardBasis = extra.name;
            extraService.startDate = extra.startDate;
            extraService.endDate = extra.endDate;
            extraService.qty = extra.qty;
            extraService.totalCostInBase = extra.totalCostInBase;
            extraService.totalSellInBase = extra.totalSellInBase;
            extraService.price = extra.totalSell;
            //#8319
            // IF the extra is a per item rate type extra the pax numbers should match the parent service pax. - Christina Gore
            extraService.adults =
              extra.rateBase && extra.rateBase == "I"
                ? item.adults
                : extra.adults;
            extraService.children =
              extra.rateBase && extra.rateBase == "I"
                ? item.children
                : extra.children;
            extraService.infants =
              extra.rateBase && extra.rateBase == "I"
                ? item.infants
                : extra.infants;
            extraService.pricing.rateTypeCode = extra.rateTypeCode;
            extraService.pricing.totalBuy = extra.totalBuy;
            extraService.rateTypeCode = extra.rateTypeCode;
            //update pricing
            extraService.pricing.infantBuy = 0;
            extraService.pricing.infantSell = 0;
            extraService.pricing.childBuy = 0;
            extraService.pricing.childSell = 0;
            extraService.pricing.adultBuy = 0;
            extraService.pricing.adultSell = 0;
            extraService.pricing.itemBuy = 0;
            extraService.pricing.itemSell = 0;
            extraService.pricing.currencyBuy = extra.currencyBuy;
            extraService.pricing.currencyBuyExchangeRate =
              extra.currencyBuyExchangeRate;
            extraService.pricing.currencySellExchangeRate =
              extra.currencySellExchangeRate;

            extraService.pricing.discountCost = Number(extra.discountCost);
            extraService.pricing.discountSell = Number(extra.discountSell);
            //#8480
            extraService.pricing.circuitDiscountCost = Number(
              //https://tracker.globetrack.ie/issues/9538
              extra.circuitDiscountCost || 0
            );
            extraService.pricing.circuitDiscountSell = Number(
              //https://tracker.globetrack.ie/issues/9538
              extra.circuitDiscountSell || 0
            );
            extraService.passComp = 0;
            extraService.supplierComp = 0;
            const extraDuration = this.duration(extraService);
            //console.log(extra, extraDuration);
            if (extra.rateBase == "P") {
              if (extra.isChildOnly) {
                extraService.pricing.childBuy = extra.cost;
                // extra.percentPrice > 0
                //   ? extra.totalBuy / extra.children / extraDuration
                //   : extra.cost;
                extraService.pricing.childSell = extra.sell;
                // extra.percentPrice > 0
                //   ? extra.totalSell / extra.children / extraDuration
                //   : extra.sell;
              } else if (extra.isInfantOnly) {
                extraService.pricing.infantBuy = extra.cost;
                // extra.percentPrice > 0
                //   ? extra.totalBuy / extra.infants / extraDuration
                //   : extra.cost;
                extraService.pricing.infantSell = extra.sell;
                // extra.percentPrice > 0
                //   ? extra.totalSell / extra.children / extraDuration
                //   : extra.sell;
              } else {
                extraService.pricing.adultBuy = extra.cost;
                // extra.percentPrice > 0
                //   ? extra.totalBuy / extra.adults / extraDuration
                //   : extra.cost;
                extraService.pricing.adultSell = extra.sell;
                // extra.percentPrice > 0
                //   ? extra.totalSell / extra.adults / extraDuration
                //   : extra.sell;
              }
            } else {
              extraService.pricing.itemBuy = extra.cost;
              // extra.percentPrice > 0
              //   ? extra.totalBuy / extra.qty
              //   : extra.cost;
              extraService.pricing.itemSell = extra.sell;
              // extra.percentPrice > 0
              //   ? extra.totalSell / extra.qty
              //   : extra.sell;
            }
            extraService.includeCommission =
              extra.commission || extra.includeCommission;
            extraService.customPricing = extra.customPricing;
            extraService.remarks = { ...extra.remarks };
            extraService.orderNo = extra.orderNo
              ? parseInt(extra.orderNo)
              : item.orderNo;
            list.push(extraService);
          }
        }
        return list.filter(this.filterItems);
      }, []);
    },
    businessModelsByCode() {
      return this.businessModels && this.businessModels.edges
        ? groupByProp(this.businessModels.edges.map(removeGQLTypename), "code")
        : {};
    },
    sortBy() {
      return this.$store.getters.localSettings("itBuilderItemsSortBy");
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    canEditPrices() {
      return this.$store.getters.hasAccessTo("itineraries:edit_prices", true);
    },
    selectedView() {
      return this.$store.getters.localSettings("itBuilderView");
    },
    headersForView() {
      const availableHeaders = this.headers.filter((h) => {
        if (h.name == "includeCommission") {
          //check for access to commission #8981
          return this.$store.getters.hasAccessTo(
            "itineraries:commission",
            true
          );
        } else {
          return true;
        }
      });
      const headers = {};
      headers["day_by_day"] = [...availableHeaders];

      headers["table"] = [...availableHeaders];
      headers["grouped"] = [...availableHeaders];
      return headers[this.selectedView]
        ? headers[this.selectedView]
        : availableHeaders;
    },
    totalPrice: function () {
      let total = 0;
      if (this.items.length > 0) {
        total = this.items
          .filter((item) => item.isIncluded)
          .reduce(
            (t, item) =>
              Number(t) +
              Number(item.price) +
              (item.extras
                ? item.extras
                    .filter((e) => e.isIncluded)
                    .reduce((te, e) => Number(te) + Number(e.totalSell), 0)
                : 0),
            total
          );
      }
      return total.toFixed(2);
    },
    filteredHeaders() {
      // return this.headers.filter(
      //   (h) => this.visibleColumns.indexOf(h.name) > -1
      // );
      const hs = [];
      for (const headerName of this.visibleColumns) {
        const h = this.headers.find((h) => h.name == headerName);
        if (h) {
          hs.push(h);
        }
      }
      return hs;
    },
    onShowCloseDays(event) {
      //console.log("on show close", event);
      //this.openAllDays = event;
    },
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.itemsWithExtras && this.itemsWithExtras.length >= 15
        ? this.windowHeight - 315
        : null;
    },
  },

  watch: {
    newItem: function (val) {
      this.showEditor = true;
      this.selectedItem = Object.assign(
        { statusId: "U2VydmljZVN0YXR1cy0x" },
        val
      );
      this.isNewItem = true;
    },
    selectedItem: function (val) {
      this.allProviderItems = [];
      //console.log("selectedItem", val);
      if (val.source && val.source.name != "GTWEB") {
        this.allProviderItems = this.itemsWithExtras.filter((item) => {
          item.itemId = item.id;
          return (
            !item.isExtra && item.source && item.source.name == val.source.name
          );
        });
        //console.log("allProviderItems", this.allProviderItems);
        if (val.source.name == "BENTRAL") {
          const statusName = val.status.toString().toUpperCase();
          const includesNonCXandNonCF =
            this.allProviderItems.filter(
              (item) =>
                item.status.toString().toUpperCase().includes("CANCELLED") ||
                item.status.toString().toUpperCase().includes("CONFIRMED")
            ).length > 0;
          console.log(
            "includesNonCXandNonCF",
            includesNonCXandNonCF,
            statusName
          );
          if (
            statusName.includes("CONFIRMED") ||
            statusName.includes("CANCELLED")
          ) {
            this.allProviderItems = [val];
          } else {
            this.allProviderItems = this.notCanceledAndNotConfirmed;
          }
        }
      }
    },
  },

  methods: {
    onIsIncludedChange(item) {
      if (item.isExtra) {
        const parent = this.items.find((i) => i.id == item.itemId);
        if (parent) {
          const actualExtra = parent.extras.find((e) => e.id == item.extraId);
          if (actualExtra) {
            actualExtra.isIncluded = item.isIncluded;
          }
        }
      } else if (item.extras) {
        for (const extra of item.extras) {
          extra.isIncluded = item.isIncluded;
        }
      }
    },
    onIsOptionalChange(item) {
      console.log("onIsOptionalChange", item);
      if (item.isExtra) {
        const parent = this.items.find((i) => i.id == item.itemId);
        if (parent) {
          const actualExtra = parent.extras.find((e) => e.id == item.extraId);
          if (actualExtra) {
            actualExtra.isOptional = item.isOptional;
          }
        }
      } else if (item.extras) {
        for (const extra of item.extras) {
          extra.isOptional = item.isOptional;
        }
      }
    },
    parentIsHidden(extraItem) {
      const parent = this.itemsWithExtras.find(
        (item) => item.id == extraItem.itemId
      );
      const parentIsHidden = parent && parent.isHidden;
      return parentIsHidden;
    },
    parentIsOptional(extraItem) {
      const parent = this.itemsWithExtras.find(
        (item) => item.id == extraItem.itemId
      );
      const parentIsOptional = parent && parent.isOptional;
      return parentIsOptional;
    },
    parentIsIncluded(extraItem) {
      const parent = this.itemsWithExtras.find(
        (item) => item.id == extraItem.itemId
      );
      const parentIsIncluded = parent && parent.isIncluded;
      return parentIsIncluded;
    },
    onDateChange(payload) {
      if (payload.customPricing) {
        //treat as new item to update pricing days nodes
        payload.id = randomize("Aa0", 32);
      }
    },
    onHideFiltersChange() {
      this.$store.dispatch("updateLocalSettings", {
        itBuilderHideFilters: this.hideFilters,
      });
    },
    filterItems(item) {
      if (this.hideFilters && Object.keys(this.hideFilters).length > 0) {
        for (const key in this.hideFilters) {
          if (this.hideFilters[key]) {
            if (Array.isArray(this.hideFilters[key])) {
              return this.hideFilters[key].indexOf(item[key]) == -1;
            } else {
              return this.hideFilters[key] != item[key];
            }
          }
        }
      } else {
        return true;
      }
    },
    onShowRemarksFromEditor() {
      this.showEditor = false;
      this.showRemarksEditor = true;
    },
    onEditRemarks(item) {
      this.selectedItem = { ...item };
      this.showRemarksEditor = true;
    },
    onSaveRemarks(payload) {
      if (this.selectedItem.isExtra) {
        console.log("updating extra remarks", payload);
        const editedExtra = this.itemsWithExtras.find(
          (item) => item.id == this.selectedItem.id
        );
        if (editedExtra) {
          editedExtra.remarks = { ...payload };
        }
        //update actual extra
        const item = this.items.find((i) => i.id == this.selectedItem.itemId);

        if (item) {
          const actualExtra = item.extras.find(
            (e) => e.id == this.selectedItem.extraId
          );
          if (actualExtra) {
            actualExtra.remarks = { ...payload };
          }
          this.updateAgGridData();
          this.$emit("item-updated", item);
        }
      } else {
        const editedItem = this.items.find(
          (item) => item.id == this.selectedItem.id
        );
        if (editedItem) {
          editedItem.remarks = { ...payload };
          //update transport pricing based on pickup and dropoff times

          if (editedItem.serviceType == "TRANSPORT") {
            const rateType = this.rateTypes.edges
              .map(removeGQLTypename)
              .find((rt) => rt.code == editedItem.rateTypeCode);

            if (rateType && rateType.includeDays) {
              //console.log("updating transport", rateType);
              updateTransportPrice(editedItem, rateType);
            }
          }

          this.updateAgGridData();
          this.$emit("item-updated", editedItem);
        }
      }

      this.showRemarksEditor = false;
    },
    onAgGridCellEditStart(payload) {
      if (!this.basicComps) {
        if (
          payload.column.colId == "supplierComp" ||
          payload.column.colId == "passComp"
        ) {
          this.$emit("show-iti-comps", payload);
          payload.api.stopEditing();
        }
      }
    },
    onShowItiComps(payload) {
      this.$emit("show-iti-comps", payload);
    },
    onShowExchangeRateUpdater(payload) {
      this.showExchangeRateUpdater = true;
    },
    onUpdateExchangeRates(payload) {
      this.showExchangeRateUpdater = false;
      this.$emit("update-exchange-rates", payload);
    },
    onCompsSave(payload) {
      EventBus.$emit("iti-items-refresh");
    },
    ondDdChange(payload) {
      this.$emit("drag-and-drop-change", payload);
    },
    onAgSelectionChanged(e) {
      //console.log(e);
      if (e.api) {
        //console.log(e.api);
        this.selectedRows = e.api
          .getSelectedNodes()
          .map((rowNode) => ({ ...rowNode.data }));
      }
    },
    onRecalculate() {
      this.$emit("onRecalculate");
    },
    onTimeChange(item) {
      if (item.isExtra) {
        const parentItem = this.items.find((i) => i.id == item.itemId);
        if (parentItem) {
          const extra = parentItem.extras.find((e) => e.id == item.extraId);
          if (extra) {
            extra.remarks.pickupTime = item.remarks.pickupTime;
            extra.remarks.timeFrom = item.remarks.pickupTime;
            extra.remarks.dropoffTime = item.remarks.dropoffTime;
          }
        }
      }
      //http://tracker.globetrack.ie/issues/6349
      if (item.serviceType == "TRANSPORT") {
        this.onRecalculate();
      }
    },
    onOrderNoChange(item) {
      if (item.isExtra) {
        const parentItem = this.items.find((i) => i.id == item.itemId);
        if (parentItem) {
          const extra = parentItem.extras.find((e) => e.id == item.extraId);
          if (extra) {
            extra.orderNo = parseInt(item.orderNo);
          }
        }
      }
    },
    updateToZeroPrices() {
      const total = this.items
        .filter(
          (item) => item.isIncluded && item.serviceType != "MANDATORY_CHARGES"
        )
        .reduce(
          (t, item) =>
            Number(t) +
            Number(item.price) +
            (item.extras
              ? item.extras.reduce(
                  (te, e) => Number(te) + Number(e.totalSell),
                  0
                )
              : 0),
          0
        );
      const toZeroCharge = this.items.find(
        (item) => item.serviceName == "TO ZERO PRICES"
      );
      toZeroCharge.pricing.adultSell = -1 * total;
      const editedIndex = this.items.findIndex((i) => i.id == toZeroCharge.id);
      Object.assign(this.items[editedIndex], {
        ...toZeroCharge,
        price: -1 * total,
      });
      //console.log("new to zero:  -", total);
    },
    onIsHiddenChange(item, $event) {
      if (item.isExtra) {
        const extra = item.extras.find((e) => e.id == item.extraId);
        if (extra) {
          extra.isHidden = $event;
        }
      } else {
        if ($event) {
          //update item extras
          for (const extra of item.extras) {
            extra.isHidden = true;
          }
        }
      }
    },
    onIncludeCommissionChange(item, $event) {
      const extra = item.extras.find((e) => e.id == item.extraId);
      if (extra) {
        extra.includeCommission = $event;
      }
    },
    onItemStatusSelect(item, payload) {
      if (item.isExtra) {
        const editedExtra = item.extras.find((e) => e.id == item.extraId);
        editedExtra.status = payload.name;
        editedExtra.statusId = payload.id;
      } else {
        const editedItem = this.items.find((i) => i.id == item.id);
        editedItem.status = payload.name;
      }
      //add log for "Cancelled with no charge"
      if (payload.id == "U2VydmljZVN0YXR1cy00") {
        item.customPricing = true;
        item.totalPrice = 0;
        this.addLog(item);
      }
    },
    itemIsDeletable(item) {
      if (item.isExtra) {
        const extra = item.extras.find((e) => e.id == item.extraId);
        if (extra && extra.isMandatory) {
          return false;
        } else {
          return true;
        }
      } else {
        return !item.isMandatory;
      }
    },

    onShowSupplier(item) {
      return () => {
        //console.log(item);
        this.$emit("supplier-edit", item);
      };
    },
    onSupplierEdit(payload) {
      this.showEditor = false;
      this.$emit("supplier-edit", payload);
    },
    showAdhocFromQuickAdd(payload) {
      this.showEditor = false;
      this.$emit("showAdhoc", payload);
    },
    showAdhocFromEdit(payload) {
      this.showEditor = false;
      this.$emit("showAdhocFromEdit", payload);
    },

    calculateOrder(item) {
      return getItiItemOrder(this.headerProps)(this.items)(item);
    },
    onVisibleColumnsChange(columns) {
      //console.log("columns changed", columns);
      this.visibleColumns = [...columns];
      this.$store.dispatch("updateLocalSettings", {
        [this.refNameColumns]: [...columns],
      });
    },
    onSelectView(view) {
      this.$store.dispatch("updateItBuilderView", view);
    },
    onExtraRemove(extra, item) {
      //console.log("removing extra: ", extra, "form item: ", item);
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        editedItem.extras = [
          ...editedItem.extras.filter((e) => e.id != extra.id),
        ];
      }
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
    statusLabeler(status) {
      return status ? status : "Quotation";
    },
    ratePlanLabeler(item) {
      if (
        item.ratePlan &&
        item.ratePlan != "" &&
        typeof item.ratePlan != "undefined"
      ) {
        return item.ratePlan;
      }
      if (
        item.pricing &&
        item.pricing.ratePlan != "" &&
        typeof item.pricing.ratePlan != "undefined"
      ) {
        return item.pricing.ratePlan;
      }
      return "";
    },
    paxLabeler(item) {
      return `${item.adults}/${item.children}/${item.infants}`;
    },
    onItemRemove(item) {
      if (item.isExtra) {
        const parentItem = this.items.find((i) => i.id == item.itemId);
        if (parentItem) {
          parentItem.extras = parentItem.extras.filter(
            (e) => e.id != item.extraId
          );
        }
      } else {
        const index = this.items.map((i) => i.id).indexOf(item.id);
        this.items.splice(index, 1);
        if (item.linkedServices && item.linkedServices.length > 0) {
          for (let linkedService of item.linkedServices) {
            const index = this.items.map((i) => i.id).indexOf(linkedService.id);
            this.items.splice(index, 1);
          }
        }
      }
      if (this.fromIncrement) {
        this.updateToZeroPrices();
      }
      this.$emit("item-removed");
    },

    priceLabeler(price) {
      return Number(price).toFixed(2);
    },
    onItemEdit(item) {
      this.selectedItem = { ...item };
      console.log("onItemEdit", item);
      this.isNewItem = false;
      if (item.serviceType == "MANDATORY_CHARGES") {
        this.$emit("edit-charge", item);
      } else {
        this.showEditor = true;
      }
    },
    onItemEditCancel($event) {
      this.showEditor = false;
    },
    onItemChanged(payload) {
      const editedItem = this.items.find((item) => item.id == payload.id);
      if (editedItem) {
        editedItem.startDate = payload.startDate;
        editedItem.endDate = payload.endDate;
        //refresh table
        this.dataTableKey = randomize("Aa0", 32);
        if (this.fromIncrement) {
          this.updateToZeroPrices();
        }
        //update agGrid
        this.updateAgGridData();
      }
    },
    onItemConfirmed(data) {
      console.log("onItemConfirmed", data);
    },
    updateAllProviderItems(data) {
      const isCancelled =
        data.status == "Cancelled" || data.status == "Cancelled with no charge";
      const isConfirmed = data.status == "Confirmed";
      const ref = data.remarks
        ? data.remarks.confirmationNo
        : data.source.confirmationRef;
      let itemsToProcess = this.allProviderItems.filter(
        (item) => item.itemId == data.id
      );
      if (data.source.name == "RESREQUEST" || isConfirmed) {
        itemsToProcess = this.notCancelled;
      }
      if (data.source.name == "BENTRAL" || isConfirmed) {
        console.log("this.allProviderItems", this.allProviderItems);
        itemsToProcess = itemsToProcess.concat(this.notCanceledAndNotConfirmed);
      }
      const refs = ref.split("\n");
      console.log("itemsToProcess", itemsToProcess);
      itemsToProcess.forEach((item) => {
        console.log("processing item", item);
        if (
          ["Confirmed", "Cancelled", "Cancelled with no charge"].indexOf(
            data.status
          ) > -1
        ) {
          item.status = data.status;
          item.statusId = data.statusId;
          item.source = data.source;
          if (item.remarks) {
            refs.forEach((r) => {
              if (r.indexOf(":") > -1) {
                const [_id, _ref] = r.split(":");
                console.log("_id, _ref", _id, _ref);
                if (_id == item.itemId) {
                  console.log("setting ref", _ref);
                  item.remarks.confirmationNo = _ref;
                }
              } else {
                item.remarks.confirmationNo = r;
              }
            });
          }
          if (item.extras) {
            item.extras.forEach((i) => {
              i.status = data.status;
              i.statusId = data.statusId;
            });
          }
          this.itemsWithExtras.forEach((i) => {
            if (i.isExtra && i.itemId == item.id) {
              i.status = data.status;
              i.statusId = data.statusId;
            }
            if (i.source && i.itemId == item.id && item.remarks) {
              i.source.confirmationRef = item.remarks.confirmationNo;
            }
            console.log("updated item", i);
          });
        }
      });
      this.allProviderItems = [];
    },
    customPricedItemDataHasChanged(c, n) {
      if (c.customPricing) {
        return this.priceParamsHasChanged(c, n);
      } else {
        return false;
      }
    },
    priceParamsHasChanged(c, n) {
      return (
        c.startDate != n.startDate ||
        c.endDate != n.endDate ||
        c.adults != n.adults ||
        c.children != n.children ||
        c.infants != n.infants ||
        c.qty != n.qty
      );
    },
    onItemEditSave({ data, action }) {
      console.log("item save", data, action);
      //find edited item
      const editedItem = this.items.find((item) => item.id == data.id);
      if (editedItem) {
        //update properties
        //check if service changed
        // for custom priced servies update id to refresh pricing days https://tracker.globetrack.ie/issues/8342 - we need to find better way of doing this
        //https://tracker.globetrack.ie/issues/9035
        const setNewId =
          editedItem.serviceId != data.serviceId ||
          this.priceParamsHasChanged(editedItem, data);
        //console.log("setNewId", setNewId);
        for (let prop of Object.keys(data)) {
          editedItem[prop] = data[prop];
        }
        if (setNewId) {
          editedItem.id = randomize("Aa0", 32);
        }
        //refresh table
        this.dataTableKey = randomize("Aa0", 32);
        if (this.fromIncrement) {
          this.updateToZeroPrices();
        }
        //only for BENTRAL and RESREQUEST
        if (
          this.allProviderItems &&
          this.allProviderItems.length > 0 &&
          (data.source.name == "BENTRAL" || data.source.name == "RESREQUEST")
        ) {
          this.updateAllProviderItems(data);
        }
        this.updateAgGridData();
        //update agGrid
        this.$emit("item-updated", editedItem);
      } else {
        //dispatch new item event
        const newItem = Object.assign({}, this.selectedItem);
        for (let prop of Object.keys(data)) {
          newItem[prop] = data[prop];
        }
        newItem.orderNo = this.calculateOrder(newItem);

        newItem.isIncluded = true;
        newItem.isOptional = false;
        //console.log("newItem", data, newItem);

        newItem.includeCommission = data.includeCommission;

        const bm = this.businessModelsByCode[newItem.businessModel]
          ? this.businessModelsByCode[newItem.businessModel][0]
          : false;
        if (bm) {
          newItem.isIncluded = bm.includesFlagOn;
          newItem.isOptional = bm.setAsOptional;
        }
        this.$emit("newItem", newItem);
      }
      if (action == "close") {
        this.showEditor = false;
      } else if (action == "save-it") {
        this.showEditor = false;
        this.$emit("save-it");
      }
    },
    duration(item) {
      let start = moment(item.startDate).startOf("day");
      let end = moment(item.endDate).startOf("day");
      if (start.isValid() && end.isValid()) {
        let d = end.diff(start, "days");
        let addDay =
          item.serviceType != "ACCOMMODATION" || item.isExtra ? 1 : 0;
        //let addDay = 1;
        if (item.serviceType == "TRANSPORT") {
          //http://tracker.globetrack.ie/issues/5905
          // only if both pickup and dropoff times are set
          if (
            item.remarks &&
            item.remarks.pickupTime &&
            item.remarks.pickupTime != "" &&
            item.remarks.dropoffTime &&
            item.remarks.dropoffTime != ""
          ) {
            const pickupTime =
              item.remarks &&
              item.remarks.pickupTime &&
              item.remarks.pickupTime != ""
                ? item.remarks.pickupTime
                : "00:00";
            const dropoffTime =
              item.remarks &&
              item.remarks.dropoffTime &&
              item.remarks.dropoffTime != ""
                ? item.remarks.dropoffTime
                : "00:01";
            addDay =
              Number(dropoffTime.replace(/\D/, "")) >
              Number(pickupTime.replace(/\D/, ""))
                ? 1
                : 0;
          }
        }
        return d == 0 ? 1 : d + addDay;
      }
      return 1;
    },
    onRemoveSelectedServices(payload) {
      const selected = payload.length ? [...payload] : [...this.selectedRows];
      this.$emit("removeSelectedServices", selected);
      this.selectedRows = [];
    },
    onReorderServices(payload) {
      const selected = payload.length ? [...payload] : [...this.selectedRows];
      this.$emit("reorderSelectedServices", selected);
      this.selectedRows = [];
    },
    onShowUpdateStatus(payload) {
      if (payload.length) {
        this.selectedRows = [...payload];
      }
      this.showUpdateStatus = true;
    },
    onUpdateStatus(payload) {
      const selected = [...this.selectedRows];
      this.$emit("updateStatus", { selected, status: { ...payload } });
      this.selectedRows = [];
      this.showUpdateStatus = false;
    },
    onCustomPriceToggle(payload) {
      const selected = payload.length ? [...payload] : [...this.selectedRows];
      this.$emit("customPriceToggle", selected);
      this.selectedRows = [];
    },
    onZeroPrices(payload) {
      const selected = payload.length ? [...payload] : [...this.selectedRows];
      this.$emit("zeroSelectedServices", selected);
      this.selectedRows = [];
    },
    onRefreshPrices(payload) {
      const selected = payload.length ? [...payload] : [...this.selectedRows];
      this.$emit("refresh-prices", selected);
      this.selectedRows = [];
    },
    onPriceAdjuster(payload) {
      if (payload.length) {
        this.selectedRows = [...payload];
      }
      this.showPriceAdjuster = true;
    },
    onPriceAdjustment(payload) {
      const selected = payload.length ? [...payload] : [...this.selectedRows];
      this.$emit("adjust-prices", {
        ...payload,
        selected,
      });
      this.selectedRows = [];
    },
    onShowPaxUpdater(payload) {
      if (payload.length) {
        this.selectedRows = [...payload];
      }
      this.showPaxUpdater = true;
    },
    onPaxUpdate(payload) {
      this.showPaxUpdater = false;

      this.$emit("updatePax", { selected: [...this.selectedRows], payload });
    },
    onMoveDaysCancel() {
      this.showMoveDays = false;
    },
    onShowMoveDays(payload) {
      if (payload.length) {
        this.selectedRows = [...payload];
      }
      this.showMoveDays = true;
    },
    onMoveDays($payload) {
      this.$emit("moveDays", { ...$payload, items: this.selectedRows });
      this.showMoveDays = false;
    },
    onEditItemPrices(item) {
      if (item.hasOwnProperty("pricing")) {
        this.selectedItem = { ...item };
        this.showItemPricingEditor = true;
      } else {
        alert("Save Your Itinerary First.");
        // TODO
        // create pricing section based on available info
      }
    },
    onPricingSave(payload) {
      if (payload.customPricing) {
        //find selected item and update it
        if (payload.isExtra) {
          const parentItem = this.items.find((i) => i.id == payload.itemId);
          //parentItem.extras = parentItem.extras.filter((e) => e.id != item.id);
          if (parentItem) {
            const editedExtra = parentItem.extras.find(
              (e) => e.id == payload.extraId
            );

            if (editedExtra) {
              if (editedExtra.rateBase == "P") {
                if (editedExtra.isChildOnly) {
                  editedExtra.cost = payload.pricing.childBuy;
                  editedExtra.sell = payload.pricing.childSell;
                } else if (editedExtra.isInfantOnly) {
                  editedExtra.cost = payload.pricing.infantBuy;
                  editedExtra.sell = payload.pricing.infantSell;
                } else {
                  editedExtra.cost = payload.pricing.adultBuy;
                  editedExtra.sell = payload.pricing.adultSell;
                }
              } else {
                editedExtra.cost = payload.pricing.itemBuy;
                editedExtra.sell = payload.pricing.itemSell;
              }

              editedExtra.rateTypeCode = payload.pricing.rateTypeCode;
              editedExtra.totalSell = payload.totalPrice;
              editedExtra.pricing = {
                currency: payload.pricing.currencyBuy,
                currencyExchangeRate: payload.pricing.currencyBuyExchangeRate,
                cost: editedExtra.cost,
                sell: editedExtra.sell,
                rateTypeCode: payload.pricing.rateTypeCode,
              };
              editedExtra.customPricing = true;
            }
            //parentItem.customPricing = true;
          }
        } else {
          const editedItem = this.items.find((item) => item.id == payload.id);
          if (editedItem) {
            editedItem.customPricing = true;
            editedItem.pricing = { ...payload.pricing };
            editedItem.price = payload.totalPrice;
            editedItem.businessModel = payload.businessModel;
            editedItem.supplierCommission = payload.supplierCommission;
            editedItem.rateTypeCode = payload.pricing.rateTypeCode;
            editedItem.yearShift = payload.yearShift;
            const bm = this.businessModelsByCode[editedItem.businessModel]
              ? this.businessModelsByCode[editedItem.businessModel][0]
              : false;
            if (bm) {
              editedItem.isIncluded = bm.includesFlagOn;
              editedItem.isOptional = bm.setAsOptional;
            }
          }
        }
      }
      this.showItemPricingEditor = false;
      if (this.fromIncrement) {
        this.updateToZeroPrices();
      }
    },
    customPricingFlagColor(item) {
      return item.customPricing ? "green darken-2" : "grey";
    },
    // until https://github.com/vuetifyjs/vuetify/issues/2890 is resolved properly
    onRatesSearch(payload) {
      this.$emit("show-rs");
    },
    onAddItem(payload) {
      //console.log("adding item from group", payload);
      // this.selectedItem = this.getItemSettingsBasedOnPayload(payload);
      // this.isNewItem = true;
      // this.showEditor = true;
      //this.showAddServiceDialog = true;
      //this.$emit("show-add-service", payload);
      this.$emit("show-sfr", payload);
    },
    onAddAdhoc(payload) {
      this.$emit("showAdhoc", payload);
    },
    onAddTemplate(payload) {
      this.$emit("showTemplate", payload);
    },
    onAddFromAllocations(payload) {
      this.$emit("show-add-from-allocations", payload);
    },
    onAddCharge() {
      this.$emit("show-add-charge");
    },

    getItemSettingsBasedOnPayload(group) {
      const item = { id: randomize("Aa0", 32) };
      if (group.fieldName == "startDate") {
        item.startDate = group.label;
        item.endDate = moment(item.startDate).add(1, "day").toISOString(true);
      } else {
        item.startDate = this.headerProps.startDate;
        item.endDate = this.headerProps.endDate;
      }
      return item;
    },
    onSortByUpdate(payload) {
      this.$store.dispatch("updateLocalSettings", {
        itBuilderItemsSortBy: payload,
      });
    },
    flagsEditDisabled(item) {
      if (item.pricing) {
        const bm = this.businessModelsByCode[item.businessModel]
          ? this.businessModelsByCode[item.businessModel][0]
          : false;
        return bm ? !bm.editableFlags : false;
      }
      return false;
    },
  },

  created() {
    EventBus.$on("showIitneraryItemEditor", (payload) => {
      // console.log("showing editor for", payload);
      // this.showEditor = true;
      // this.selectedItem = Object.assign(
      //   { statusId: "U2VydmljZVN0YXR1cy0x" },
      //   payload
      // );
      // this.isNewItem = true;
    });
  },

  apollo: {
    businessModels: {
      query: BUSINESS_MODELS,
    },
    rateTypes: {
      query: ALL_RATE_TYPES_SEARCH_QUERY,
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>

<style>
.v-dialog {
  position: absolute;
  top: 0;
}
.iti-items-list.v-data-table td,
.iti-items-list.v-data-table th {
  font-size: 1em !important;
}
.ag-root-wrapper {
  overflow: visible;
}
#ag-it-builder-items-list {
  height: calc(100vh - 755px);
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemsList.vue